// extracted by mini-css-extract-plugin
export default {"button":"Button_button__-qjCB","smallButton":"Button_smallButton__qFfn3"};